export const selectRow = (api, rowIndex) => {
  if (!api) return;
  const rowCount = api.getDisplayedRowCount();
  if (!rowCount) return;
  const rowNode = api.getDisplayedRowAtIndex(rowIndex);
  if (!rowNode)return;
  api.ensureIndexVisible(rowIndex);
  api.getDisplayedRowAtIndex(rowIndex)?.setSelected(true);
};

export const focusCell = (api, rowIndex, column) => {
  if (!api) {
    return;
  }
  const rowSelected = api.getRowNode(rowIndex)?.selected;
  if (!rowSelected) {
    selectRow(api, rowIndex);
  }
  if (column?.colDef?.editable) {
    if (
      api.getFocusedCell()?.rowIndex !== rowIndex ||
      api.getFocusedCell()?.column?.colId !== column?.colId
    )
      api.setFocusedCell(rowIndex, column.colId);

    api.startEditingCell({
      rowIndex,
      colKey: column.colId,
    });
  }
};

export const cellTabbed = (api, shiftKey) => {
  if (document.getElementsByClassName("MuiAutocomplete-listbox").length)
    return true;
  api.deselectAll();
  if (shiftKey) {
    if (api.tabToPreviousCell()) {
      focusCell(
        api,
        api.getFocusedCell().rowIndex,
        api.getFocusedCell().column
      );
    } else {
      return false;
    }
  } else if (api.tabToNextCell()) {
    focusCell(api, api.getFocusedCell().rowIndex, api.getFocusedCell().column);
  } else {
    return false;
  }
  return true;
};

export const cellClicked = (api, rowIndex, column, ctrlKey = false) => {
  if (column) {
    focusCell(api, rowIndex, column);
  }
};
/*
    column: optional parameter. mandatory if cell is editable
  */
export const rowUp = (api, ctrlKey = false, column = null) => {
  if (!api) return;
  if (document.getElementsByClassName("MuiAutocomplete-listbox").length)
    return true;
  const currentRow = api.getSelectedNodes()[0]?.rowIndex;
  if (ctrlKey) {
    let isChecked = api.getRowNode(currentRow).data.checked || false;
    api.getRowNode(currentRow).data.checked = !isChecked;
    api.redrawRows({ rowNodes: [api.getRowNode(currentRow)] });
  }
  if (currentRow === 0) {
    return false;
  }
  if (column) {
    focusCell(api, currentRow - 1, column);
    return true;
  }
  selectRow(api, currentRow - 1);
  return true;
};

export const rowDown = (api, ctrlKey = false, column = null) => {
  if (!api) return;
  if (document.getElementsByClassName("MuiAutocomplete-listbox").length)
    return true;
  const currentRow = api.getSelectedNodes()[0]?.rowIndex;
  if (ctrlKey) {
    let isChecked = api.getRowNode(currentRow).data.checked || false;
    api.getRowNode(currentRow).data.checked = !isChecked;
    api.redrawRows({ rowNodes: [api.getRowNode(currentRow)] });
  }
  if (currentRow === api.getDisplayedRowCount() - 1) {
    return false;
  }
  if (column) {
    focusCell(api, currentRow + 1, column);
    return true;
  }
  selectRow(api, currentRow + 1);
  return true;
};
export const stopEditing = (api) => {
  api.clearFocusedCell();
  api.deselectAll();
  api.stopEditing();
};

export const fetchColumnConfigFromDB = (identifier) => {
  return localStorage.getItem(identifier);
};

export const initializeColumnDefsFns = (col_def, defFns = {}) => {
  let updatedColDef = [...col_def];
  const colDefs = updatedColDef.map((colDef) => {
    if (defFns[colDef.field]) {
      colDef = { ...colDef, ...defFns[colDef.field] };
    }
    return colDef;
  });
  return colDefs;
};

export const initializeColumnDefs = (api, identifier, colDef, defFns) => {
  let columnConfig = fetchColumnConfigFromDB(identifier);
  let col_defs = null;
  if (columnConfig) {
    col_defs = JSON.parse(columnConfig);
  } else {
    col_defs = colDef;
    localStorage.setItem(identifier, JSON.stringify(col_defs));
  }
  col_defs = initializeColumnDefsFns(col_defs, defFns);
  setTimeout(() => {
    api?.setColumnDefs(col_defs);
  }, 1);
  return col_defs;
};

export const getAllRows = (api) => {
  if (!api) return;
  let rowNodes = [];
  api.forEachNode((node) => rowNodes.push(node.data));
  return rowNodes;
};

export const updateColumnDefs = (api, identifier, colDefs) => {
  localStorage.setItem(identifier, JSON.stringify(colDefs));
  api?.setColumnDefs([...colDefs]);
  return true;
};
